import { render, staticRenderFns } from "./IconUserX.vue?vue&type=template&id=0b1b9e21&"
import script from "./IconUserX.vue?vue&type=script&lang=js&"
export * from "./IconUserX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports